/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { find } from '../fn/user-inventory-preference-controller/find';
import { Find$Params } from '../fn/user-inventory-preference-controller/find';
import { updateById } from '../fn/user-inventory-preference-controller/update-by-id';
import { UpdateById$Params } from '../fn/user-inventory-preference-controller/update-by-id';
import { UserInventoryPreferenceWithRelations } from '../models/user-inventory-preference-with-relations';

@Injectable({ providedIn: 'root' })
export class UserInventoryPreferenceControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userInventoryPreferenceControllerFind()` */
  static readonly UserInventoryPreferenceControllerFindPath = '/user/inventory-preference/{inventoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: Find$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInventoryPreferenceWithRelations>> {
    return find(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: Find$Params, context?: HttpContext): Observable<UserInventoryPreferenceWithRelations> {
    return this.find$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInventoryPreferenceWithRelations>): UserInventoryPreferenceWithRelations => r.body)
    );
  }

  /** Path part for operation `userInventoryPreferenceControllerUpdateById()` */
  static readonly UserInventoryPreferenceControllerUpdateByIdPath = '/user/inventory-preference/{inventoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: UpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInventoryPreferenceWithRelations>> {
    return updateById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: UpdateById$Params, context?: HttpContext): Observable<UserInventoryPreferenceWithRelations> {
    return this.updateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInventoryPreferenceWithRelations>): UserInventoryPreferenceWithRelations => r.body)
    );
  }

}
